// extracted by mini-css-extract-plugin
export default {"page":"v1-z","cartModal":"w1-z","checkout":"x1-z","placeholder":"y1-z","account":"z1-z"};